

const requiredEnvVars = [
    'REACT_APP_API',
    'REACT_APP_URL_FACEKOOK',
    'REACT_APP_URL_YOUTUBE',
    'REACT_APP_URL_IN',
    'REACT_APP_USE_MOCK_API',
    'REACT_APP_HOST',
    'REACT_APP_GENERAL_DONATION',
];

// 检查必填环境变量
const missingVars = requiredEnvVars.filter(key => typeof process.env[key] === 'undefined');
if (missingVars.length > 0) {
    throw new Error(`缺少必要的环境变量: ${missingVars.join(', ')}`);
}


//配置開發模式
class Config {
    REACT_APP_API = String(process.env['REACT_APP_API'])
    REACT_APP_URL_FACEKOOK = String(process.env['REACT_APP_URL_FACEKOOK'])
    REACT_APP_URL_YOUTUBE = String(process.env['REACT_APP_URL_YOUTUBE'])
    REACT_APP_URL_IN = String(process.env['REACT_APP_URL_IN'])
    REACT_APP_URL_LINKEDIN = String(process.env['REACT_APP_URL_LINKEDIN'] || 'https://www.linkedin.com/company/food-angel-by-bo-charity-foundation/?originalSubdomain=hk')
    REACT_APP_USE_MOCK_API = Boolean(Number(process.env['REACT_APP_USE_MOCK_API']))
    REACT_APP_HOST = String(process.env['REACT_APP_HOST'])
    REACT_APP_GENERAL_DONATION = String(process.env['REACT_APP_GENERAL_DONATION'])
}

const config = new Config()
export default config

